import options from './label-details.component';

export default {
    selector: 'dtLabelDetailsView',
    options
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/labels/label-details/index.js